export * from "./Bom2aCellDescription";
